import script from "./CardBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./CardBanner.vue?vue&type=script&setup=true&lang=js"

import "./CardBanner.vue?vue&type=style&index=0&id=caada65a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-caada65a"]])

export default __exports__